<template>
  <div>
    <template v-if="isLoading">
      <div class="row">
        <div class="col-md-12 text-center">
          <loader class="loader">
            <p slot="text">Loading...</p>
          </loader>
        </div>
      </div>
    </template>
    <template v-else>
      <template v-if="versionsForAuthor.length === 0">
        <div class="row">
          <div class="col-md-12 text-center">
            <div class="panel panel-default version-card">
              <div class="panel-body">
                <div class="row">
                  <div class="col-md-12 text-center mt-20">
                    <h4>
                      <em>
                        No projects yet. Click the green "New Project" button to start your first
                        project.</em
                      >
                    </h4>
                    <div class="mt-20 mb-20">
                      <router-link
                        :tag="'button'"
                        class="btn btn-lg btn-success mat ml-10"
                        :to="{ name: 'new-version' }"
                      >
                        <span class="fas fa-plus-circle mr-5"></span> New Project</router-link
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="flex-inline flex-wrap version-container">
          <template v-for="(version, idx) in versionList">
            <version-card
              v-show="versionShowStatus[idx]"
              :key="`version-card-${idx}`"
              :version="version"
              :is-admin="isAdmin"
              @send="handleSend"
              @share="handleShare"
              @delete="handleDelete"
              @duplicate="handleDuplicate"
              @publish="handlePublish"
            />
          </template>
        </div>
      </template>
    </template>

    <modal id="confirm-delete-version" :show-footer="false">
      <h3 class="m-0" slot="title">Delete Version</h3>
      <div slot="body" class="text-center">
        <p>Are you sure you want to delete "{{ selectedVersion.versionName }}"?</p>
        <button @click="handleConfirmDelete(selectedVersion.versionKey)" data-testid="version-deletion-cy" class="btn btn-danger mat">
          Confirm
        </button>
      </div>
    </modal>

    <share-version-modal
      id="share-version-modal"
      :version-name="selectedVersion.versionName"
      :versionKey="selectedVersion.versionKey"
    />

    <send-copy
      id="send-copy-modal"
      v-if="isAdmin"
      :version-key="selectedVersion.versionKey"
      :version-name="selectedVersion.versionName"
    />

    <publish :version-key="selectedVersion.versionKey" />
  </div>
</template>

<script>
  import ShareVersionModal from './ShareVersionModal.vue';
  import SendCopy from './SendCopy.vue';
  import VersionCard from './VersionCard';
  import { mapActions, mapGetters, mapState } from 'vuex';
  import Publish from './Publish';
  import Loader from '@shared/loader.vue';
  export default {
    name: 'ListVersions',

    props: {
      searchText: {
        type: String,
        required: true,
      },

      showMineOnly: {
        type: Boolean,
        default: false,
      },

      isAdmin: {
        type: Boolean,
        required: true,
      },
    },

    data() {
      return {
        selectedVersion: {},
      };
    },

    components: {
      ShareVersionModal,
      SendCopy,
      VersionCard,
      Publish,
      Loader,
    },

    computed: {
      ...mapState('user', ['actorKey', 'isAdmin']),
      ...mapGetters('versions', ['versionList', 'isLoading']),

      versionShowStatus() {
        if (this.searchText) {
          const lowerCaseSearchText = this.searchText.toLowerCase();
          return this.versionList.map(({ versionName, authorName }) => {
            return (
              (versionName && versionName.toLowerCase().includes(lowerCaseSearchText)) ||
              (authorName && authorName.toLowerCase().includes(lowerCaseSearchText))
            );
          });
        }
        const currUserActorKey = this.actorKey;
        if (this.showMineOnly && this.isAdmin) {
          return this.versionList.map((version) => version.actorKey === currUserActorKey);
        }
        return this.versionList.map(() => true);
      },
      versionsForAuthor() {
        return this.versionList.filter((version) => version.actorKey === this.actorKey);
      },
    },

    methods: {
      ...mapActions('versions', ['deleteVersion', 'duplicateVersion']),

      handleDelete(version) {
        this.selectedVersion = version;
        $('#confirm-delete-version').modal('show');
      },

      async handleConfirmDelete(versionKey) {
        await this.deleteVersion({ versionKey });
        this.selectedVersion = {};
        $('#confirm-delete-version').modal('hide');
      },

      async handleDuplicate(versionKey) {
        await this.duplicateVersion({ versionKey });
      },

      handleShare(version) {
        this.selectedVersion = version;
        $('#share-version-modal').modal('show');
      },

      handleSend(version) {
        this.selectedVersion = version;
        $('#send-copy-modal').modal('show');
      },
      handlePublish(version) {
        this.selectedVersion = version;
        $('#publish-version').modal({ backdrop: 'static', keyboard: false });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .version-container {
    margin: calc(-1 * 5px) 0 0 calc(-1 * 5px);
    width: calc(100% + 5px);

    & > * {
      margin: 5px 0 10px 5px;
      width: calc(100% / 3 - 5px);
    }
  }
  .version-card {
    .panel-heading,
    .panel-footer {
      background: white;
    }
  }
</style>
